module.exports = __webpack_public_path__ + "img/time-tracking.4dadd836.svg";